import Link from "next/link";
import Head from "next/head";
import marked from "marked";
import MuiIndexMarkupWrap from "components/global/MuiIndexMarkupWrap";
import { NextSeo } from "next-seo";

export async function getStaticProps() {
  const targetUrl = `${process.env.CMS_URL}/about-us`;
  const res = await fetch(targetUrl);
  const AboutData = await res.json();

  return {
    props: {
      AboutData,
    },
  };
}

export default function About({ AboutData }) {
  return (
    <>
      <NextSeo
        title={AboutData?.MetaTitle}
        description={AboutData?.MetaDescription}
        image={`${process.env.absoluteUrl}/omlogo_placeholder.png`}
        // canonical="https://www.offermarket.us/"
        openGraph={{
          url: `${process.env.absoluteUrl}/about`,
          title: AboutData?.MetaTitle,
          description: AboutData?.MetaDescription,
          images: [
            {
              url: `${process.env.absoluteUrl}/omlogo_placeholder.png`,
              alt: AboutData?.MetaTitle,
            },
          ],
          site_name: "OfferMarket.us",
        }}
        twitter={{
          handle: "@OfferMarketUS",
          site: "@OfferMarketUS",
          cardType: "summary_large_image",
        }}
      />
      <MuiIndexMarkupWrap>
        <h1
          style={{
            margin: "auto",
          }}
        >
          {AboutData?.Title}
        </h1>
        <div dangerouslySetInnerHTML={{ __html: marked(AboutData?.Body) }} />
      </MuiIndexMarkupWrap>
    </>
  );
}
